/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal, Label, Loader } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';

class ChangeOwnerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCO: props.isOpenMCO,
      searchKeyword: '',
      errSearch: false,
      memberList: [],
      selectedId: '',
      currentPage: 1,
      pageSize: 20,
      isMemberListLoading: false,
      error: null,
      hasMore: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.searchMember = this.searchMember.bind(this);
    this.handleProjectMemberChange = this.handleProjectMemberChange.bind(this);
    this.handleSearchMember = this.handleSearchMember.bind(this);
    this.handleSelectedOwner = this.handleSelectedOwner.bind(this);
    this.handleMemberListScroll = this.handleMemberListScroll.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMCO } = this.props;

    if (prevProps.isOpenMCO !== isOpenMCO) {
      this.setState({
        isOpenMCO,
        searchKeyword: '',
        errSearch: false,
        memberList: [],
        selectedId: '',
        currentPage: 1,
        pageSize: 20,
        isMemberListLoading: false,
        error: null,
        hasMore: false,
      }, () => {
        if (isOpenMCO) {
          this.searchMember();
        }
      });
    }
  }

  handleProjectMemberChange(e) {
    this.setState({
      searchKeyword: e.target.value,
    });
  }

  handleSearchMember(event) {
    if (event.key === 'Enter') {
      this.setState(
        {
          memberList: [],
        },
        () => {
          this.searchMember();
        }
      );
    }
  }

  /*
  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;

    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }
  */

  handleSelectedOwner(ownerId) {
    if (ownerId === this.state.selectedId) {
      this.setState({
        selectedId: '',
      });
    } else {
      this.setState({
        selectedId: ownerId,
      });
    }
  }

  handleMemberListScroll(event) {
    const {
      searchMember,
      state: {
        error, isMemberListLoading, hasMore, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isMemberListLoading || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      searchMember(currentPage + 1);
    }
  }

  onSubmit() {
    const { memberList, selectedId } = this.state;

    const selectedOwner = memberList.filter((item) => {
      return selectedId === item.id;
    });

    this.setState({
      isOpenMCO: false,
    });
    this.props.closeModal();
    this.props.completeCallback(selectedOwner);
  }

  closeModal(e) {
    if (e.target.classList[0] === 'item') {
      return;
    }
    this.setState({
      isOpenMCO: false,
    });
    this.props.closeModal();
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        memberList: [],
      },
      () => {
        this.searchMember();
      }
    );
  }

  searchMember(pageNo, limit) {
    const { searchKeyword, pageSize, memberList } = this.state;
    const { members, translate } = this.props;
    const page = pageNo || 1;
    const memberPerPage = limit || pageSize;

    const newArray = [];
    let i = 0;
    for (i; i < members.length; i++) {
      newArray.push(members[i].email);
    }

    if (page !== 1) {
      this.setState({
        isMemberListLoading: true,
      });
    }

    api
      .searchMember({
        search: searchKeyword || '',
        owners: [this.props.owners.email],
        members: newArray,
        search_type: 'owners',
        page,
        limit: memberPerPage,
      })
      .then((response) => {
        const nextData = response.response;
        this.setState({
          //totalCount: response.count,
          currentPage: response.pagination.current,
          //totalPage: response.pagination.pages,
          hasMore: response.pagination.next !== null,
          memberList: [...memberList, ...nextData],
          isMemberListLoading: false,
          error: null,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isMemberListLoading: false,
          error: translate('modal.error.error_load'),
        });
      });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  render() {
    const {
      searchKeyword,
      errSearch,
      memberList,
      selectedId,
      isMemberListLoading,
      error,
    } = this.state;
    const { translate } = this.props;

    return (
      <Modal
        open={this.state.isOpenMCO}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.changing_project_owner')}
                  <em>{this.props.projectName}</em>
                </h2>
                <a
                  className="popup_close_button"
                  placeholder={translate('modal.title.label_name_email')}
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={translate('modal.title.label_name_email')}
                        onChange={this.handleProjectMemberChange}
                        onKeyPress={this.handleSearchMember}
                      />
                      <a className="reset_icon" onClick={this.clearSearch} onKeyUp={this.clearSearch}>
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div
                      className="table_wrap table_type_3"
                      style={{ height: '322px' }}
                    >
                      <Scrollbars
                        onScroll={this.handleMemberListScroll}
                      >
                        <table className="table table_type_3">
                          <colgroup>
                            <col style={{ width: '50%' }} />
                            <col style={{ width: '50%' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <th>{translate('settings.list.user_name')}</th>
                              <th>{translate('settings.list.email')}</th>
                            </tr>
                            {memberList.length !== 0 ? (
                              memberList.map((item) => {
                                return (
                                  <tr
                                    key={uuidv4()}
                                    className={cx('hover_area', {
                                      selected: selectedId === item.id,
                                    })}
                                    onClick={() => {
                                      this.handleSelectedOwner(item.id);
                                    }}
                                  >
                                    <td className="strong">{item.profile}</td>
                                    <td className="strong">
                                      {this.convertToString(item.email)}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="2">
                                  {translate('settings.message.need_to_member')}
                                </td>
                              </tr>
                            )}
                            {error && <div className="error_log">{error}</div>}
                            {isMemberListLoading && (
                              <Loader active={isMemberListLoading} size="small" inline="centered" />
                            )}
                          </tbody>
                        </table>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a className="button save_button" onClick={this.onSubmit} onKeyUp={this.onSubmit}>
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ChangeOwnerModal;
